import type {DecorationPlugin} from '../types'
import {nicknamesPlugin} from './nicknames'
import {typesPlugin} from './types'
import {serdesPlugin} from './serdes'

export const decorationPlugins: DecorationPlugin[] = [typesPlugin, nicknamesPlugin, serdesPlugin]
